import {
  FETCH_FOOD_REQUEST,
  FETCH_FOOD_SUCCESS,
  FETCH_FOOD_FAILURE,
  CREATE_FOOD_REQUEST,
  CREATE_FOOD_SUCCESS,
  CREATE_FOOD_FAILURE,
  UPDATE_FOOD_REQUEST,
  UPDATE_FOOD_SUCCESS,
  UPDATE_FOOD_FAILURE,
  DELETE_FOOD_REQUEST,
  DELETE_FOOD_SUCCESS,
  DELETE_FOOD_FAILURE,
  UPLOAD_EXCEL_FOOD_REQUEST,
  UPLOAD_EXCEL_FOOD_SUCCESS,
  UPLOAD_EXCEL_FOOD_FAILURE
} from "./foodActionTypes";

export const fetchFoodRequest = () => ({
  type: FETCH_FOOD_REQUEST,
});

export const fetchFoodSuccess = (data, dataType) => ({
  type: FETCH_FOOD_SUCCESS,
  payload: { data, type: dataType },
});

export const fetchFoodFailure = (error) => ({
  type: FETCH_FOOD_FAILURE,
  payload: error,
});

export const createFoodRequest = () => ({
  type: CREATE_FOOD_REQUEST,
});

export const createFoodSuccess = (data, dataType) => ({
  type: CREATE_FOOD_SUCCESS,
  payload: { data, type: dataType },
});

export const createFoodFailure = (error) => ({
  type: CREATE_FOOD_FAILURE,
  payload: error,
});

export const updateFoodRequest = () => ({
  type: UPDATE_FOOD_REQUEST,
});

export const updateFoodSuccess = (data, dataType) => ({
  type: UPDATE_FOOD_SUCCESS,
  payload: { data, type: dataType },
});

export const updateFoodFailure = (error) => ({
  type: UPDATE_FOOD_FAILURE,
  payload: error,
});

export const deleteFoodRequest = () => ({
  type: DELETE_FOOD_REQUEST,
});

export const deleteFoodSuccess = (data, dataType) => ({
  type: DELETE_FOOD_SUCCESS,
  payload: { data, type: dataType },
});

export const deleteFoodFailure = (error) => ({
  type: DELETE_FOOD_FAILURE,
  payload: error,
});

export const uploadExcelFoodRequest = () => ({
  type: UPLOAD_EXCEL_FOOD_REQUEST
});

export const uploadExcelFoodSuccess = (data) => ({
  type: UPLOAD_EXCEL_FOOD_SUCCESS,
  payload: data
});

export const uploadExcelFoodFailure = (error) => ({
  type: UPLOAD_EXCEL_FOOD_FAILURE,
  payload: error
});